import { AutogenModelExtraPayDeductCode, AutogenRowExtraPayDeductCode } from "./autogen/AutogenModelExtraPayDeductCode";

export class ModelExtraPayDeductCode extends AutogenModelExtraPayDeductCode<RowExtraPayDeductCode> {
    constructor() {
        super(RowExtraPayDeductCode);
    }
}

export class RowExtraPayDeductCode extends AutogenRowExtraPayDeductCode {
}